import { render } from "./CompaniesSenderId.vue?vue&type=template&id=ebd11bd8"
import script from "./CompaniesSenderId.vue?vue&type=script&lang=js"
export * from "./CompaniesSenderId.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__